
import { Card } from "@/components/ui/card";

interface DashboardWelcomeProps {
  firstName: string;
  lastName: string;
  selectedClientName: string;
}

export const DashboardWelcome = ({ firstName, lastName, selectedClientName }: DashboardWelcomeProps) => {
  const displayName = selectedClientName ? selectedClientName : firstName || "User";
  console.log("DashboardWelcome rendering with:", { firstName, lastName, selectedClientName, displayName });
  
  return (
    <Card className="p-4 sm:p-6 bg-white">
      <h1 className="text-2xl sm:text-3xl font-semibold text-[#1A1F2C] mb-2 sm:mb-4">
        Welcome, <span className="text-primary">{displayName}</span>
      </h1>
      <p className="text-sm sm:text-base text-[#8E9196]">
        {selectedClientName 
          ? "Manage client policies and insurance information here."
          : "Manage your Kover King Policies"}
      </p>
    </Card>
  );
};
